import { ContentType, request } from "../api";
import { baseParams } from "../common";

const paymentSystemsResultFormat = data => {
  return data.map(item => ({
    id: item["id"],
    code: item["code"],
    logo: item["logo"],
    name: item["name"],
    description: JSON.parse(item["description"]),
    commission_value: item["commission_value"],
    amount: item["amount"],
  }));
};

export const getPaymentSystems = async (purpose, order_id = null, params = {}, amount = null) => {
  // order_id — комиссия считается от суммы заказа, amount — от суммы пополнения баланса (бек ads_v1)
  const response = await request({
    path: "/payment-systems",
    method: "POST",
    secure: true,
    body: { ...baseParams, purpose, ...(order_id ? { order_id } : {}), ...(amount ? { amount } : {}) },
    type: ContentType.Json,
    format: "json",
    ...params,
  });

  return paymentSystemsResultFormat(response.data);
};
